import { usePosterContext } from "../../context/poster-context";
import { PosterTab } from "../../hooks/use-poster";
import {
  PosterMakerTabLeftButton,
  PosterMakerTabLeftWrapper,
  PosterMakerTabRightWrapper,
  PosterMakerTabWrapper,
} from "./styles/tab.style";

const PosterMakerTab = () => {
  const { tab, setTab, selectedTournament, selectedTemplate, handleReset } =
    usePosterContext();

  const handleTabClick = () => {
    if (!selectedTournament) {
      alert("토너먼트를 선택해주세요.");
      return false;
    }
    if (!selectedTemplate) {
      alert("템플릿을 선택해주세요.");
      return false;
    }
    return true;
  };

  return (
    <PosterMakerTabWrapper>
      <PosterMakerTabLeftWrapper>
        <PosterMakerTabLeftButton
          onClick={() => setTab(PosterTab.TEMPLATE)}
          selected={tab === PosterTab.TEMPLATE}
        >
          템플릿
        </PosterMakerTabLeftButton>
        <PosterMakerTabLeftButton
          onClick={() => {
            if (handleTabClick()) {
              if (selectedTemplate === 2) {
                setTab(PosterTab.COLOR);
              } else {
                alert("템플릿2번만 배경 색상 수정 가능합니다.");
              }
            }
          }}
          selected={tab === PosterTab.COLOR}
        >
          배경 색상
        </PosterMakerTabLeftButton>
        <PosterMakerTabLeftButton
          onClick={() => {
            if (handleTabClick()) {
              setTab(PosterTab.INFO);
            }
          }}
          selected={tab === PosterTab.INFO}
        >
          정보 수정
        </PosterMakerTabLeftButton>
      </PosterMakerTabLeftWrapper>
      <PosterMakerTabRightWrapper>
        <div className="text">초기화</div>
        <img
          src="/image-web/poster/reset.svg"
          alt="reset"
          onClick={() => {
            if (window.confirm("초기화하시겠습니까?")) {
              handleReset();
            }
          }}
        />
        <div className="text">저장</div>
        <img
          src="/image-web/poster/download.svg"
          alt="save"
          onClick={() => {
            if (handleTabClick()) {
              // 이미지 다운로드 이벤트 발생
              window.dispatchEvent(new Event("download-poster-image"));
            }
          }}
        />
      </PosterMakerTabRightWrapper>
    </PosterMakerTabWrapper>
  );
};

export default PosterMakerTab;
